"use client";

export {
  create as createModal,
  NiceModalContext,
  show as showModal,
  useModal,
} from "@ebay/nice-modal-react";
